import LocalForage from 'localforage';

// Синглтон для взаимодействия с фингер принтом
export default class FingerPrint {
	private static instance: FingerPrint;

	private projectId: number;
	private newFingerPrint: string; // Уже сгенерированный уникальный крипто ключ
	private generatedFingerPrint: string | null; // Кешируем ключ, чтобы быстрей его возвращать
	private FPStore!: LocalForage;

	private constructor(projectId: number, newFingerPrint: string) {
		if (FingerPrint.instance) {
			throw new Error('Error - use FingerPrint.getInstance()');
		}

		this.newFingerPrint = newFingerPrint;
		this.generatedFingerPrint = null;
		this.projectId = projectId;
	}

	static getInstance(projectId: number, newFingerPrint: string): FingerPrint {
		FingerPrint.instance =
			FingerPrint.instance || new FingerPrint(projectId, newFingerPrint);
		return FingerPrint.instance;
	}

	get fingerKey() {
		return `fp_respondent_${this.projectId}`;
	}

	private createLocalForageInstance() {
		this.FPStore = LocalForage.createInstance({
			name: 'FPStore',
			size: 10240, // Size of database, in bytes. WebSQL-only for now.
			storeName: 'fp_store' // Should be alphanumeric, with underscores.
		});
	}

	public async getFingerPrint(): Promise<string> {
		if (!this.FPStore) {
			await this.createLocalForageInstance();
		}

		// Если уже вызывали этот метод, то у нас должен быть сгенерирован ключ уже
		if (this.generatedFingerPrint) {
			return this.generatedFingerPrint;
		}

		this.generatedFingerPrint = (await this.FPStore.getItem(this.fingerKey)) as string;

		if (!this.generatedFingerPrint) {
			this.generatedFingerPrint = await this.FPStore.setItem(
				this.fingerKey,
				this.newFingerPrint
			);
		}

		return this.generatedFingerPrint;
	}
}
